import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import styles from "./inline-question.module.scss";

export default class InlineQuestion extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      collapsed:
        typeof props.defaultExpanded !== "undefined"
          ? !props.defaultExpanded
          : true,
    };
  }

  getState = () => {
    return this.state.collapsed ? "" : styles.expanded;
  };

  toggleState = () => {
    this.setState({ collapsed: !this.state.collapsed });
  };

  render() {
    const { answer, question, email } = this.props;
    return (
      <div className={styles["inline-question"]}>
        <div onClick={this.toggleState}>
          <div className={styles.chevron + " " + this.getState()}>
            <svg viewBox="0 0 52 52" onClick={this.toggleState}>
              <line x1={1} y1={25} x2={51} y2={25} />
              <line x1={1} y1={25} x2={51} y2={25} />
            </svg>
          </div>
          <h6
            className={styles.question + " text-body-medium " + this.getState()}
          >
            {question}
          </h6>
        </div>
        {answer &&
          !this.state.collapsed &&
          answer.map((paragraph, index) => {
            const content =
              typeof paragraph === "string"
                ? paragraph
                : paragraph(email);
            return (
              <p
                className={`col-12 col-md-10 col-xl-8 ${styles.answer} text-body-small`}
                key={index}
                dangerouslySetInnerHTML={{ __html: content }}
              ></p>
            );
          })}
      </div>
    );
  }
}

InlineQuestion.propTypes = {
  defaultExpanded: PropTypes.bool,
  email: PropTypes.string.isRequired,
  question: PropTypes.string.isRequired,
  answer: PropTypes.arrayOf([PropTypes.string, PropTypes.func]),
};

InlineQuestion.defaultProps = {
  answer: ["Answer not available"],
  defaultExpanded: false,
};
